import React from "react";

import Logo from "../../../assets/images/logo_banco_occidente.png";
import { useCreateAcincoContext } from "../create/provider/createAcinco.provider";
import { useCreateNewsAcincoContext } from "../create/news/provider/createNewsAcinco.provider";
import { useCreateUsedAcincoContext } from "../create/used/provider/createUsedAcinco.provider";
import { useLoginUser } from "../../../hooks/useLoginUser";

const Navbar = () => {
  const { setFlow, setStep, step } = useCreateAcincoContext();
  const { handleInitialState: handleInitialStateNews } =
    useCreateNewsAcincoContext();
  const { handleInitialState: handleInitialStateUsed } =
    useCreateUsedAcincoContext();
  const { logout } = useLoginUser();

  const handleLogout = () => {
    setFlow("new");
    handleInitialStateUsed();
    handleInitialStateNews();
    logout();
    setStep(1);
  };

  return (
    <nav className={`fixed z-40 w-full bg-white`}>
      <div className="max-w-screen flex md:px-32">
        <div className="ml-10 flex w-full items-center justify-between px-5 lg:px-0">
          <div className="-ml-7 w-64 lg:ml-0 lg:w-96">
            <img
              alt="acinco_acinco_logo"
              src={Logo}
              className="img-fluid w-full"
            />
          </div>
          {step > 2 && (
            <div className="text-center">
              <button
                type="button"
                className="text-center"
                onClick={() => handleLogout()}
              >
                Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
